import {find} from 'lodash-es';

import * as AssetActions from '../../../state/assets/assets.action';
import * as SearchActions from '../../../state/search/search.action';

export class AssetListFooterController {
  constructor($scope, $ngRedux) {
    'ngInject';

    this.$scope = $scope;
    this.store = $ngRedux;

    this.selectedPage = 1;
    this.numPages = 1;
  }

  $onInit() {
    this.unsubscribe = this.store.connect(this.mapStateToThis, {...AssetActions, ...SearchActions})(this);
  }

  $onDestroy() {
    this.unsubscribe();
  }

  export() {
    this.searchExport();
  }

  mapStateToThis(state) {
    const {assets} = state;
    const {exportInProgress} = state.search;
    const pageSize = find(assets.pageSizes, item => item.value === assets.pageSize);

    return {
      totalAssetCount: assets.totalCount,
      selectedPage: assets.currentPage,
      numPages: assets.totalPages,
      pageSizes: assets.pageSizes,
      pageSize,
      exportInProgress
    };
  }

  hasMoreResults() {
    return this.selectedPage < this.numPages;
  }

  setPageSize() {
    this.store.dispatch(this.updatePageSize(this.pageSize.value));
  }

  selectPage() {
    // invoke bound search trigger function, passing the selected page index and result limit
    this.store.dispatch(this.selectPage(this.selectedPage));
  }

  previousPage() {
    this.selectPage(this.selectedPage - 1);
  }

  nextPage() {
    this.selectPage(this.selectedPage + 1);
  }

  sinceForPage(page, limit) {
    return (page - 1) * limit;
  }

  getNotice() {
    this.showNotice();
  }
}

export const assetListFooterComponent = {
  restrict: 'E',
  bindings: {
    showNotice: '&'
  },
  controller: 'AssetListFooterController as vm'
};
